<!-- eslint-disable vuejs-accessibility/no-static-element-interactions -->
<template>
  <div
    class="promo-container"
    :style="`--background-colour: ${colours.background};`"
  >
    <div class="promo-banner critical-component-hide">
      <span
        class="visually-hidden"
        v-text="$string('general.site_header.promo_banner')"
      />

      <splide
        class="promo-banner__list"
        :class="`promo-banner__list--${colours.content}`"
        :options="carouselOptions"
      >
        <template
          v-for="(block, index) of blocks"
          :key="`promo-${index}`"
        >
          <splide-slide v-if="block.title">
            <div
              class="
                promo-banner__list-item
                text-body-xs-regular
                text-body-s-regular-desktop
              "
              v-html="getBlockText(block.title)"
            />
          </splide-slide>
        </template>
      </splide>

      <div class="promo-banner__multi-store">
        <multi-store-form
          form-id="promo_banner"
          form-theme="light"
        />
      </div>
    </div>
  </div>
</template>

<script>

/**
 * Vue: Promo banner (promo-banner)
 * -----------------------------------------------------------------------------
 * Promo banner template.
 * - Conditionally loaded when section has blocks.
 *
 * @param {Object} timing - Timing section settings.
 * @param {Object} colours - Color settings.
 * @param {Array} blocks - Promo blocks.
 * @param {Object} liquid - Liquid section ID, used for theme editor events.
 *
 */
import { Splide, SplideSlide } from '@splidejs/vue-splide'

import MultiStoreForm from '~global/multi-store-form/multi-store-form'

export default {
  name: 'PromoBanner',

  components: {
    Splide,
    SplideSlide,
    MultiStoreForm,
  },

  props: {
    timing: {
      type: Number,
      default: 3500,
    },
    colours: {
      type: Object,
      default: () => ({
        content: 'white',
        background: '#000000',
      }),
    },
    blocks: {
      type: Array,
      default: () => [],
    },
    // Needed for theme editor events
    // eslint-disable-next-line vue/no-unused-properties
    liquid: {
      type: Object,
      default: () => ({
        sectionId: '',
      }),
    },
  },

  data() {
    return {
      activeSlide: 1,
      carouselOptions: {
        arrows: false,
        autoHeight: true,
        autoplay: true,
        interval: this.timing * 1000,
        pagination: false,
        pauseOnFocus: true,
        pauseOnHover: true,
        rewind: true,
        type: 'fade',
      },
    }
  },

  async mounted() {
    await this.$nextTick()
    cnvs.EventBus.emit('cnvs:update-site-header-height')
  },

  methods: {

    /**
     * Get block text.
     * - Applies text class to <a> elements.
     * @param {String} block - Block text.
     * @returns {String}
     */
    getBlockText(block) {
      return block
        .replaceAll('<a', '<a class="text-body-xs-regular text-body-s-regular-desktop"')
        .replaceAll('<strong', '<strong class="text-body-xs-regular text-body-s-regular-desktop"')
    },
  },
}
</script>

<style lang="scss">
@import './promo-banner';
@import '@/components/splide'
</style>
